import type { AnchorHTMLAttributes, ReactNode } from "react"
import { ArrowUpRight } from "lucide-react"

type ButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode
  variant?: "primary" | "ghost"
  arrow?: boolean
}

export function Button({ children, variant = "primary", arrow = true, className = "", ...props }: ButtonProps) {
  return (
    <a className={`button button--${variant} ${className}`} {...props}>
      <span>{children}</span>
      {arrow && <ArrowUpRight aria-hidden="true" size={17} strokeWidth={1.8} />}
    </a>
  )
}
